// GiftCertificate/GiftCertificatePage.tsx

import React, {useEffect, useState} from 'react';
import {CircularProgress, Typography} from '@mui/material';
import {useNavigate, useParams} from 'react-router-dom';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import pprint from '../../Utils/pprint';
import {FC, FCCC, FRSC} from 'WideLayout/Layouts';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import {useTheme} from 'Theme/ThemeContext';

import {IGiftCertificate} from "../../Types/commerce/gift_certificate";
import GiftCertificateDetail from "GiftCertificate/GiftCertificateDetail";
import Head from "Core/components/Head";

interface GiftCertificatePageProps {
    giftCertificate?: IGiftCertificate;
    cls?: string;
}

const GiftCertificatePage: React.FC<GiftCertificatePageProps> = ({giftCertificate: propGiftCertificate, cls}) => {
    const {productId} = useParams<{ productId: string }>();
    const [giftCertificate, setGiftCertificate] = useState<IGiftCertificate | null>(propGiftCertificate || null);
    const [loading, setLoading] = useState<boolean>(!propGiftCertificate);
    const [error, setError] = useState<string | null>(null);
    const {plt} = useTheme();
    const navigate = useNavigate();

    useEffect(() => {
        if (!propGiftCertificate && productId) {
            const fetchGiftCertificate = async () => {
                try {
                    const response = await axios.get(`/api/v1/gift-certificates/${productId}/`);
                    pprint('Gift Certificate fetched:', response.data);
                    setGiftCertificate(response.data);
                } catch (err: any) {
                    console.error('Error fetching gift certificate:', err);
                    setError('Ошибка при загрузке подарочного сертификата.');
                } finally {
                    setLoading(false);
                }
            };
            fetchGiftCertificate();
        }
    }, [productId, propGiftCertificate]);

    if (loading)
        return (
            <FCCC h={'100%'}>
                <CircularProgress size={'150px'}/>
            </FCCC>
        );
    if (error)
        return (
            <Typography color="error" align="center" mt={4}>
                {error}
            </Typography>
        );
    if (!giftCertificate)
        return (
            <Typography align="center" mt={4}>
                Подарочный сертификат не найден
            </Typography>
        );

    return (
        <><Head
            title={`Сертификат ${giftCertificate.name} | Лайф Хелп`}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/gift-certificate/${giftCertificate.id}`}/><FC cls={cls} px={2} pb={2} g={1}
                                                                                       h={'100%'}>
            <FRSC
                mt={1}
                g={1}
                color={plt.text.primary50}
                onClick={() => navigate('/gift-certificates')}
            >
                <ArrowBackIosNewRoundedIcon fontSize={'small'}/>
                <span className={'pt-2px'}>Все подарочные сертификаты</span>
            </FRSC>
            <FC scroll={'y-auto'}>
                <GiftCertificateDetail giftCertificate={giftCertificate}/>
            </FC>
        </FC></>
    );
};

export default GiftCertificatePage;
